import React, { ReactElement, useEffect, useState } from 'react'
import { ScreenSize } from '../../Constants/MediaQuery'
// Commons imports.
import Icon, { IconName } from '../Icon'
// Sub imports.
import { TabsMenuItem } from './Types'

export type TabItem = TabsMenuItem & { active: boolean }

/**
 * Component properties type.
 */
type Props = {
    tabsMenuItems: TabItem[]
    isVisible: boolean
}

/**
 * Vertically layout-ed tabs menu.
 *
 * @param tabsMenuItems List of tabs menu items.
 */
const VerticalTabsMenu: React.FC<Props> = ({ tabsMenuItems, isVisible }: Props): ReactElement => {
    const [isTitleVisible, setIsTitleVisible] = useState(true)
    const MOBILE_MAX_TABS = 2

    const updateTitleState = (): void => {
        if (window.innerWidth < ScreenSize.SCREEN_SM_MAX && tabsMenuItems.length > MOBILE_MAX_TABS) {
            setIsTitleVisible(false)
        } else {
            setIsTitleVisible(true)
        }
    }

    useEffect(() => {
        updateTitleState()
        window.addEventListener('resize', updateTitleState)

        return (): void => {
            window.removeEventListener('resize', updateTitleState)
        }
    }, [])
    /**
     * Builds the tab menu item.
     * @param tab The tab menu item settings.
     * @param index index of the tab in menu.
     */
    const toTabMenuItem = (tab: TabItem, index: number): ReactElement => {
        const { title, iconName, onClick, active, hasError, className }: TabItem = tab

        const tabItemClass = `tab-menu-item ${className} ${active ? 'active-item' : ''} ${
            hasError ? 'tab-has-errors' : ''
        }`
        return (
            // eslint-disable-next-line @typescript-eslint/no-base-to-string
            <div key={`${title.toString()}-tabs-${index}`} className={tabItemClass} onClick={onClick}>
                <div className='tab-icon'>
                    <Icon iconName={iconName} />
                </div>
                {isTitleVisible && <div className='title'>{title}</div>}
                <div className={`${active ? '' : 'hide'} active-icon`}>
                    <Icon iconName={IconName.ARROW_RIGHT} />
                </div>
            </div>
        )
    }

    return (
        <div className='vertical-tabs-menu' style={{ display: !isVisible ? 'none' : '' }}>
            {tabsMenuItems.map(toTabMenuItem)}
        </div>
    )
}

export default VerticalTabsMenu
